import * as React from "react";

function SvgNoDemand(props) {
  return <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M2 8h12" stroke="#26B6AE" /></svg>;
}

export default SvgNoDemand;